<template>
  <div>
    <div class="form-group">
      <label for="nome">Número</label>
      <input
        type="text"
        v-mask="'(##) # ####-####'"
        class="form-control"
        v-model="form.number"
      />
    </div>
    <div class="form-group">
      <label for="nome">Mensagem</label>
      <textarea rows="3" class="form-control" v-model="form.message">
      </textarea>
    </div>
    <a class="btn btn-success" @click.prevent="submit">Enviar Mensagem</a>
  </div>
</template>

<script>
import makeToast from '../../mixins/makeToast';

export default {
  name: 'WhatsApp',
  mixins: [makeToast],

  data() {
    return {
      form: {
        number: null,
        message: null,
      },
    };
  },

  methods: {
    submit() {
      if (this.form.number === null && this.form.message === null) {
        this.makeToast('Oopss', 'Preencha todos os campos!', 'danger');
        return;
      }
      this.$store.dispatch('startLoader');
      this.$store
        .dispatch('submitWhatsapp', this.form)
        .then((data) => {
          this.makeToast('Sucesso', 'Mensagem enviada com sucesso!', 'success');
        })
        .catch(() =>
          this.makeToast('Oopss', 'Erro ao enviar mensagem!', 'danger')
        )
        .finally(() => this.$store.dispatch('endLoader'));
    },
  },
};
</script>

<style></style>
